/**
 * GetResultsByPage Function
 * 
 * This function returns a subset of results for the specified page.
 * The number of results per page is fixed at 10.
 * 
 * @param {T[]} results - The array of results to paginate.
 * @param {number} page - The page number to retrieve.
 * @returns {T[]} The subset of results for the specified page.
 */
export function GetResultsByPage<T>(results: T[], page: number, resultsPerPage?: number | null): T[] {
    const perPage = resultsPerPage ?? (Number(process.env.REACT_APP_RESULTS_PER_PAGE) || 10);
    const startIndex = (page - 1) * perPage;
    const endIndex = startIndex + perPage;
    return results.slice(startIndex, endIndex);
}